<template lang="pug">
  footer#footer.lm-footer
</template>

<script>
export default {
  name: 'lm-footer',
}
</script>
